export type PaginationType = {
  currentPage: number;
  limit: number;
  totalItems: number;
  totalPages: number;
  startPage: number;
  endPage: number;
  startIndex: number;
  endIndex: number;
  pages: Array<number>;
  prev: number;
  next: number;
  hasPrev: boolean;
  hasNext: boolean;
  prev10: number;
  next10: number;
  hasPrev10: boolean;
  hasNext10: boolean;
  maxPages: number;
};

export const paginate = (
  currentPage: number,
  limit: number,
  totalItems: number,
  maxPages = 10,
): PaginationType => {
  // calculate total pages
  const totalPages = Math.ceil(totalItems / limit);

  // ensure current page isn't out of range
  if (currentPage < 1) {
    currentPage = 1;
  } else if (currentPage > totalPages) {
    currentPage = totalPages;
  }

  let startPage: number, endPage: number;
  if (totalPages <= maxPages) {
    // total pages less than max so show all pages
    startPage = 1;
    endPage = totalPages;
  } else {
    // total pages more than max so calculate start and end pages
    const maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
    const maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
    if (currentPage <= maxPagesBeforeCurrentPage) {
      // current page near the start
      startPage = 1;
      endPage = maxPages;
    } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
      // current page near the end
      startPage = totalPages - maxPages + 1;
      endPage = totalPages;
    } else {
      // current page somewhere in the middle
      startPage = currentPage - maxPagesBeforeCurrentPage;
      endPage = currentPage + maxPagesAfterCurrentPage;
      //startPage = currentPage - 1
      //endPage = currentPage + 1
    }
  }

  let nextPage!: number,
    prevPage!: number,
    hasNext = false,
    hasPrev = false,
    next10Page!: number,
    prev10Page!: number,
    hasNext10 = false,
    hasPrev10 = false;
  // next page
  //if (currentPage > endPage - 1) {
  if (currentPage > totalPages) {
    nextPage = currentPage;
  } else {
    nextPage = currentPage + 1;
    hasNext = true;
  }
  // previous page
  if (currentPage <= 1) {
    prevPage = 1;
  } else {
    prevPage = currentPage - 1;
    hasPrev = true;
  }

  // calculate start and end item indexes
  const startIndex = currentPage > 0 ? (currentPage - 1) * limit : 0;
  const endIndex = Math.min(startIndex + limit - 1, totalItems - 1);

  // create an array of pages to ng-repeat in the pager control
  const pages = Array.from(Array(endPage + 1 - startPage).keys()).map(
    (i) => startPage + i,
  );
  //if pages start with 2 , add 1 to first position.
  if (pages[0] === 2) {
    pages.splice(0, 0, 1);
  }

  // next 10 page
  if (pages.length && !pages.includes(totalPages)) {
    hasNext10 = true;
    next10Page = currentPage + 10;
    if (next10Page >= totalPages) {
      next10Page = totalPages;
    }
  }
  // previous 10 page
  if (pages.length && !pages.includes(1)) {
    hasPrev10 = true;
    prev10Page = currentPage - 10;
    if (prev10Page <= 1) {
      prev10Page = 1;
    }
  }

  // return object with all pager properties required by the view
  return {
    currentPage,
    limit,
    totalItems,
    totalPages,
    startPage,
    endPage,
    startIndex,
    endIndex,
    pages,
    prev: prevPage,
    next: nextPage,
    hasPrev,
    hasNext,
    prev10: prev10Page,
    next10: next10Page,
    hasPrev10,
    hasNext10,
    maxPages,
  };
};

export function getMaxPageNum(
  width: number,
  isHalfPage: boolean,
  hasPrev10: boolean,
  hasNext10: boolean,
) {
  const LRPadding = 64;
  const effectiveWidth = isHalfPage ? width / 2 - LRPadding : width - LRPadding;
  const itemWidth = 56; // width of each page number button
  const buttonWidth = 56; // width of < and > buttons
  let buttonCount = 5; // 2 arrows + 2 ellipses (or adjust if you have more/fewer)

  if (hasPrev10) buttonCount += 1;

  if (hasNext10) buttonCount += 1;

  const usableWidth = effectiveWidth - buttonCount * buttonWidth;

  // Minimum: always show at least 2 page numbers
  //if (width <= 450) return 1;

  // Main calculation: how many full 56px items fit
  let itemFit = Math.floor(usableWidth / itemWidth);

  return Math.max(2, itemFit);
}
